<template>
<div id="login_modal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-body">
                <div class="modal-user-login">
                    <div class="modal-user-login__mask" v-if="loading">
                        <spinner message="Logging In..."></spinner>
                    </div>
                    <form @submit.prevent="doLogin">
                        <div class="form-group">
                            <input
                                type="email"
                                v-model="form.email"
                                v-validate="'required|email'"
                                class="form-control form-input"
                                :class="{'is-danger': errors.first('login-form.email')}"
                                placeholder="Indirizzo email"
                            />
                            
                            <span class="invalid-feedback" v-if="errors.first('login-form.email')">
                                {{errors.first('login-form.email')}}
                            </span>
                        </div>
                        <div class="form-group password-container">
                            <input
                                :type="passwordShown ? 'text' : 'password'"
                                class="form-input form-control"
                                v-validate="'required'"
                                v-model="form.password"
                                :class="{'is-danger': errors.first('login-form.password')}"
                                placeholder="Password"
                            />

                            <i 
                                v-if="!passwordShown"
                                class="far fa-eye showHidePassword showPassword"
                                @click="showPassword"></i>

                            <i 
                                v-if="passwordShown"
                                class="far fa-eye-slash showHidePassword hidePassword"
                                @click="hidePassword"></i>
                        </div>

                        <button type="submit" class="btn btn-default btn-block btn-primary text-capitalize">Accedi</button>
                    </form>

                    <a class="modal-user-login__forgot-password" href="/password/reset">Password dimenticata?</a>
                    <div class="modal-user-login__divider">
                        <span>oppure</span>
                    </div>
                    <div class="modal-user-login__social-buttons">
                        <GoogleButton></GoogleButton>
                        <FacebookButton></FacebookButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import FacebookButton from '../buttons/FacebookButton'
    import GoogleButton from '../buttons/GoogleButton'
    import Spinner from 'vue-simple-spinner';

    export default {
        name: 'UserLogin',
        props: ['title'],
        components: {
            FacebookButton,
            GoogleButton,
            Spinner
        },
        data() {
            return {
                passwordShown: false,
                form: {},
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                redirect: 'loginRedirect'
            }),
            isVisible: {
                set(boolean) {
                    this.$store.commit('SET_LOGIN_SHOW', boolean)
                },
                get() {
                    return this.$store.state.globalModals.login.show;
                }
            }
        },
        methods: {
            showPassword() {
                this.passwordShown = true
            },
            hidePassword() {
                this.passwordShown = false
            },
            doLogin() {
                this.$validator.validate().then(result => {
                    if (result) {
                        this.loading = true;
                        axios({
                            method: 'post',
                            url: '/auth/login',
                            data: this.form
                        }).then((response) => {
                            this.$bus.$emit('user_logged_in', response.data);

                            this.loading = false;
                            window.alerts.success('Accesso effettuato correttamente');
                            $('#login_modal').modal('hide')
                        }).catch((err) => {
                            this.loading = false;
                            this.handleError(err.response);
                        });
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/LoginModal.vue